import React, { useState } from 'react';
import {
  MoreOutlined,
  QuestionCircleOutlined,
  MessageOutlined,
} from '@ant-design/icons';
import { Dropdown, Menu } from 'antd';
import axios from 'axios';
import PropTypes from 'prop-types';

import { request } from '../helpers/requests';

import OttoChatBase from './OttoChatBase';
import OttoFeedback from './OttoFeedback';

const helpUrl = 'https://help.ontraccr.com/en/article/using-otto-your-ai-assistant-in-ontraccr';

function OttoChat({ visible, onClose }) {
  const [feedbackVisible, setFeedbackVisible] = useState(false);

  const handleSendFeedback = () => {
    setFeedbackVisible(true);
  };

  const handleHowToUse = () => {
    window.open(helpUrl, '_blank', 'noopener,noreferrer');
  };

  const handleMenuClick = ({ key }) => {
    switch (key) {
      case 'feedback':
        handleSendFeedback();
        break;
      case 'how-to-use':
        handleHowToUse();
        break;
      default:
        break;
    }
  };

  const handleSend = async (message, threadId) => {
    const payload = { message };
    if (threadId) {
      payload.threadId = threadId;
    }

    const res = await request({
      call: () => (
        axios.post('/otto/message', payload)
      ),
      successMsg: 'Message sent',
      errMsg: 'Failed to send message',
    });

    return {
      threadId: res?.data?.threadId,
      response: res?.data?.response,
    };
  };

  const headerActions = (
    <Dropdown
      overlay={(
        <Menu onClick={handleMenuClick}>
          <Menu.Item key="feedback">
            <MessageOutlined /> Send Feedback
          </Menu.Item>
          <Menu.Item key="how-to-use">
            <QuestionCircleOutlined /> How To Use
          </Menu.Item>
        </Menu>
      )}
      placement="bottomRight"
      trigger={['click']}
    >
      <MoreOutlined className="otto-chat-action-icon" />
    </Dropdown>
  );

  return (
    <>
      <OttoChatBase
        visible={visible}
        onClose={onClose}
        title="Otto: Your AI Assistant"
        placeholder="Ask me anything"
        loadingText="Otto is thinking..."
        headerActions={headerActions}
        onSend={handleSend}
        defaultWidth="480px"
        fullscreenWidth="calc(100vw - 220px)"
      />
      <OttoFeedback
        visible={feedbackVisible}
        onClose={() => setFeedbackVisible(false)}
      />
    </>
  );
}

OttoChat.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default OttoChat;
